function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { filterUndefined, memoisedGet as get, mergeWith, runIfFn } from '../utils';
import { useContext, useMemo, useRef } from 'react';
import isEqual from 'react-fast-compare';
import { omitThemingProps } from './system.utils';
import { ThemeContext } from '@emotion/react';
export function useTheme() {
  var theme = useContext(ThemeContext);
  if (!theme) {
    throw Error('useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<TQCProvider />`');
  }
  return theme;
}

/**
 * @deprectated Use `useTheme`
 */
export function useTQC() {
  var theme = useTheme();
  return {
    theme
  };
}
export function useToken(scale, token, fallback) {
  var theme = useTheme();
  if (Array.isArray(token)) {
    var fallbackArr = [];
    if (fallback) {
      fallbackArr = Array.isArray(fallback) ? fallback : [fallback];
    }
    return token.map((token, index) => {
      var _fallbackArr$index;
      var path = "".concat(scale, ".").concat(token);
      return get(theme, path, (_fallbackArr$index = fallbackArr[index]) !== null && _fallbackArr$index !== void 0 ? _fallbackArr$index : token);
    });
  }
  var path = "".concat(scale, ".").concat(token);
  return get(theme, path, fallback !== null && fallback !== void 0 ? fallback : token);
}
export function useProps(themeKey, props) {
  var _theme$components, _styleConfig$defaultP;
  var {
    theme
  } = useTQC();
  var styleConfig = props.styleConfig || ((_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components[themeKey]);
  var defaultProps = (_styleConfig$defaultP = styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.defaultProps) !== null && _styleConfig$defaultP !== void 0 ? _styleConfig$defaultP : {};
  var propsWithDefault = _objectSpread(_objectSpread({}, defaultProps), filterUndefined(props));
  var stylesRef = useRef({});
  var mergedProps = mergeWith({}, propsWithDefault, {
    theme
  });
  var memoisedStyles = useMemo(() => {
    if (styleConfig) {
      var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes, _styleConfig$sizes2;
      var baseStyles = runIfFn((_styleConfig$baseStyl = styleConfig.baseStyle) !== null && _styleConfig$baseStyl !== void 0 ? _styleConfig$baseStyl : {}, mergedProps);
      var variants = runIfFn((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) === null || _styleConfig$variants2 === void 0 ? void 0 : _styleConfig$variants2[mergedProps.variant]) !== null && _styleConfig$variants !== void 0 ? _styleConfig$variants : {}, mergedProps);
      var sizes = runIfFn((_styleConfig$sizes = (_styleConfig$sizes2 = styleConfig.sizes) === null || _styleConfig$sizes2 === void 0 ? void 0 : _styleConfig$sizes2[mergedProps.size]) !== null && _styleConfig$sizes !== void 0 ? _styleConfig$sizes : {}, mergedProps);
      var styles = mergeWith(baseStyles, sizes, variants);
      if (styleConfig.parts) {
        styleConfig.parts.forEach(part => {
          var _styles$part;
          styles[part] = (_styles$part = styles[part]) !== null && _styles$part !== void 0 ? _styles$part : {};
        });
      }
      var isStyleEqual = isEqual(stylesRef.current, styles);
      if (!isStyleEqual) {
        stylesRef.current = styles;
      }
    }
    return stylesRef.current;
  }, [styleConfig, mergedProps]);
  return {
    styles: memoisedStyles,
    props: omitThemingProps(propsWithDefault)
  };
}